export default "__VITE_ASSET__d9882e14__"